export default "__VITE_ASSET__CowPU8Rf__"